module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pl-menu', {
    staticClass: "z-10 text-xs",
    attrs: {
      "direction": "right",
      "menuSize": 4
    }
  }, [_c('button', {
    staticClass: "w-8 h-8 hover:bg-coolGray-200 rounded-full",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('i', {
    staticClass: "fas fa-ellipsis-v text-sm text-gray-500"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "menu-content": ""
    }
  }, [(!_vm.hasTeacherPermissionsInCourse && _vm.entry.flagged_by) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.entry.flagged_by.includes(_vm.getProfile.id)),
      expression: "entry.flagged_by.includes(getProfile.id)"
    }],
    staticClass: "sample cursor-pointer py-3 px-4 text-xs items-center hover:bg-coolGray-100",
    attrs: {
      "id": "flag"
    },
    on: {
      "click": function($event) {
        return _vm.flagToggle(_vm.entry.id)
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "mx-3 text-sm"
  }, [_vm._v("Unflag")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.hasTeacherPermissionsInCourse && _vm.entry.flagged_by) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.entry.flagged_by.includes(_vm.getProfile.id)),
      expression: "!entry.flagged_by.includes(getProfile.id)"
    }],
    staticClass: "sample cursor-pointer py-3 px-4 text-xs hover:bg-coolGray-100",
    attrs: {
      "id": "flag"
    },
    on: {
      "click": _vm.flagClick
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center text-red-500"
  }, [_c('span', [_vm._v("Flag as inappropriate")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.entry.is_model_submission) ? _c('li', {
    staticClass: "sample cursor-pointer py-3 px-4 flex justify-between items-center w-full hover:bg-coolGray-100",
    on: {
      "click": function($event) {
        return _vm.editEntry(_vm.entry)
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "mx-3 text-sm"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.entry.flagged_by.length) ? _c('li', {
    staticClass: "sample cursor-pointer py-3 px-4 flex justify-between items-center w-full hover:bg-coolGray-100",
    attrs: {
      "id": "flag"
    },
    on: {
      "click": function($event) {
        return _vm.teacherUnflagComment(_vm.entry.id)
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "mx-3 text-sm"
  }, [_vm._v("Unflag Comment")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && !_vm.entry.is_model_submission) ? _c('li', {
    staticClass: "sample cursor-pointer py-3 px-4 flex justify-between items-center w-full hover:bg-coolGray-100",
    on: {
      "click": _vm.handleCommentClick
    }
  }, [(!_vm.entry.is_hidden) ? [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "mx-3 text-sm"
  }, [_vm._v("Hide Comment")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-eye-slash"
  })])] : [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "mx-3 text-sm"
  }, [_vm._v("Reveal Comment")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-eye"
  })])]], 2) : _vm._e(), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('li', {
    staticClass: "sample group px-3 py-2 rounded-t flex justify-between items-center w-full h-9 cursor-pointer hover:bg-gray-100",
    on: {
      "click": function($event) {
        return _vm.deleteEntry(_vm.type)
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "mx-3 text-sm"
  }, [_vm._v("Delete")]), _vm._v(" "), _c('i', {
    staticClass: "text-red-500 fas fa-trash-alt mr-1"
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.show_flag_dialog) ? _c('pl-dialog', {
    attrs: {
      "header": "Are you sure you would like to flag this?"
    },
    on: {
      "close": function($event) {
        _vm.show_flag_dialog = false
      }
    }
  }, [_c('div', {
    staticClass: "row end-xs"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.cancelDelete()
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('confirm-flag', 'flag')
      }
    }
  }, [_vm._v("OK")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.show_delete_comment_dialog) ? _c('pl-dialog', {
    attrs: {
      "maxWidth": '500px',
      "header": "Are you sure you want to DELETE this comment?"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_comment_dialog = false
      }
    }
  }, [_c('pl-input', {
    attrs: {
      "labelText": _vm.label_confirm_msg,
      "errorMessage": _vm.error_message_computed
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.closeDialog('confirm-delete-comment', 'delete-comment')
      }
    },
    model: {
      value: (_vm.confirm),
      callback: function($$v) {
        _vm.confirm = $$v
      },
      expression: "confirm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row end-xs"
  }, [_c('pl-button', {
    staticClass: "pl-primary-font",
    nativeOn: {
      "click": function($event) {
        _vm.show_delete_comment_dialog = false
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary-font",
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('confirm-delete-comment', 'delete-comment')
      }
    }
  }, [_vm._v("OK")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.show_hide_comment_modal) ? _c('pl-confirm', {
    staticClass: "tl",
    attrs: {
      "typeConfirm": false,
      "confirmText": "HIDE"
    },
    on: {
      "confirm": _vm.hideComment,
      "close": function($event) {
        _vm.show_hide_comment_modal = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "pl-title bold"
  }, [_vm._v("Hide Comment")]), _vm._v(" "), _c('p', [_vm._v("\n        This will hide the comment and associated replies from participants in\n        the RoundTable. Only you and the original poster can see it from now\n        on.\n      ")]), _vm._v(" "), _c('p', [_vm._v("You can undo this at any time.")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2b510ccb!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/entryOptions/entryOptions.vue
// module id = 1095
// module chunks = 61